var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWallPaper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 390,
    height: 844,
    viewBox: "0 0 390 844",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1717_2149)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 390,
    height: 844,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 47,
    width: 390,
    height: 216.667,
    fill: "url(#pattern0)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391,
    y: 848,
    width: 392,
    height: 852,
    transform: "rotate(-180 391 848)",
    fill: "url(#paint0_linear_1717_2149)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 831,
    width: 138,
    height: 5,
    rx: 2.5,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.2773,
    y: 709,
    width: 12.5897,
    height: 12.6,
    fill: "#FDC5D7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 723.7,
    width: 12.5897,
    height: 12.6,
    fill: "#FDC5D7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.5059,
    y: 722.65,
    width: 12.5897,
    height: 12.6,
    fill: "#FDC5D7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.963,
    y: 722.65,
    width: 12.5897,
    height: 12.6,
    fill: "#FDC5D7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.519,
    y: 722.65,
    width: 12.5897,
    height: 12.6,
    fill: "#FDC5D7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.2773,
    y: 737.35,
    width: 12.5897,
    height: 12.6,
    fill: "#FDC5D7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.2773,
    y: 762.55,
    width: 12.5897,
    height: 12.6,
    fill: "#FDC5D7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 762.75,
    width: 17,
    height: 12,
    fill: "#FDC5D7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 774.75,
    width: 17,
    height: 13,
    fill: "#FDC5D7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 800.75,
    width: 17,
    height: 12,
    fill: "#FDC5D7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.688,
    y: 775.15,
    width: 12.5897,
    height: 12.6,
    fill: "#FDC5D7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.2773,
    y: 787.75,
    width: 12.5897,
    height: 12.6,
    fill: "#FDC5D7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.688,
    y: 800.35,
    width: 12.5897,
    height: 12.6,
    fill: "#FDC5D7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.8672,
    y: 800.35,
    width: 12.5897,
    height: 12.6,
    fill: "#FDC5D7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 787.75,
    width: 15,
    height: 13,
    fill: "#FDC5D7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.8672,
    y: 775.15,
    width: 12.5897,
    height: 12.6,
    fill: "#FDC5D7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.1943,
    y: 775.15,
    width: 12.5897,
    height: 12.6,
    fill: "#FDC5D7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.1943,
    y: 787.75,
    width: 12.5897,
    height: 12.6,
    fill: "#FDC5D7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.1943,
    y: 800.35,
    width: 12.5897,
    height: 12.6,
    fill: "#FDC5D7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.7837,
    y: 787.75,
    width: 12.5897,
    height: 12.6,
    fill: "#FDC5D7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.3735,
    y: 775.15,
    width: 12.5897,
    height: 12.6,
    fill: "#FDC5D7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.963,
    y: 775.15,
    width: 12.5897,
    height: 12.6,
    fill: "#FDC5D7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.553,
    y: 775.15,
    width: 12.5897,
    height: 12.6,
    fill: "#FDC5D7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.143,
    y: 762.55,
    width: 12.5897,
    height: 12.6,
    fill: "#FDC5D7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.3735,
    y: 787.75,
    width: 12.5897,
    height: 12.6,
    fill: "#FDC5D7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.3735,
    y: 800.35,
    width: 12.5897,
    height: 12.6,
    fill: "#FDC5D7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.963,
    y: 800.35,
    width: 12.5897,
    height: 12.6,
    fill: "#FDC5D7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.553,
    y: 787.75,
    width: 12.5897,
    height: 12.6,
    fill: "#FDC5D7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.143,
    y: 787.75,
    width: 12.5897,
    height: 12.6,
    fill: "#FDC5D7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.732,
    y: 775.15,
    width: 12.5897,
    height: 12.6,
    fill: "#FDC5D7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.553,
    y: 800.35,
    width: 12.5897,
    height: 12.6,
    fill: "#FDC5D7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.519,
    y: 800.35,
    width: 13.6388,
    height: 12.6,
    fill: "#FDC5D7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 177.157,
    y: 787.75,
    width: 12.5897,
    height: 12.6,
    fill: "#FDC5D7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 177.157,
    y: 800.35,
    width: 12.5897,
    height: 12.6,
    fill: "#FDC5D7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.337,
    y: 800.35,
    width: 12.5897,
    height: 12.6,
    fill: "#FDC5D7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 177.157,
    y: 775.15,
    width: 12.5897,
    height: 12.6,
    fill: "#FDC5D7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.747,
    y: 762.55,
    width: 12.5897,
    height: 12.6,
    fill: "#FDC5D7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.747,
    y: 787.75,
    width: 12.5897,
    height: 12.6,
    fill: "#FDC5D7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.337,
    y: 775.15,
    width: 12.5897,
    height: 12.6,
    fill: "#FDC5D7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202,
    y: 787.75,
    width: 17,
    height: 13,
    fill: "#FDC5D7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.219,
    y: 787.75,
    width: 12.5897,
    height: 12.6,
    fill: "#FDC5D7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297.809,
    y: 787.75,
    width: 12.5897,
    height: 12.6,
    fill: "#FDC5D7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.398,
    y: 787.75,
    width: 12.5897,
    height: 12.6,
    fill: "#FDC5D7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.398,
    y: 800.35,
    width: 12.5897,
    height: 12.6,
    fill: "#FDC5D7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.219,
    y: 800.35,
    width: 12.5897,
    height: 12.6,
    fill: "#FDC5D7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.988,
    y: 762.55,
    width: 15.7371,
    height: 12.6,
    fill: "#FDC5D7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.988,
    y: 775.15,
    width: 15.7371,
    height: 12.6,
    fill: "#FDC5D7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.988,
    y: 800.35,
    width: 15.7371,
    height: 12.6,
    fill: "#FDC5D7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 231.713,
    y: 787.75,
    width: 12.5897,
    height: 12.6,
    fill: "#FDC5D7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 231.713,
    y: 775.15,
    width: 12.5897,
    height: 12.6,
    fill: "#FDC5D7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.302,
    y: 762.55,
    width: 12.5897,
    height: 12.6,
    fill: "#FDC5D7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.302,
    y: 787.75,
    width: 12.5897,
    height: 12.6,
    fill: "#FDC5D7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 231.713,
    y: 800.35,
    width: 12.5897,
    height: 12.6,
    fill: "#FDC5D7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257,
    y: 787.75,
    width: 16,
    height: 13,
    fill: "#FDC5D7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.892,
    y: 800.35,
    width: 12.5897,
    height: 12.6,
    fill: "#FDC5D7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.892,
    y: 775.15,
    width: 12.5897,
    height: 12.6,
    fill: "#FDC5D7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.482,
    y: 762.55,
    width: 15.7371,
    height: 12.6,
    fill: "#FDC5D7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.482,
    y: 775.15,
    width: 15.7371,
    height: 12.6,
    fill: "#FDC5D7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.482,
    y: 800.35,
    width: 15.7371,
    height: 12.6,
    fill: "#FDC5D7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.927,
    y: 800.35,
    width: 16.7863,
    height: 12.6,
    fill: "#FDC5D7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.927,
    y: 775.15,
    width: 16.7863,
    height: 12.6,
    fill: "#FDC5D7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.927,
    y: 762.55,
    width: 16.7863,
    height: 12.6,
    fill: "#FDC5D7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.732,
    y: 787.75,
    width: 16.7863,
    height: 12.6,
    fill: "#FDC5D7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147,
    y: 799.75,
    width: 16,
    height: 14,
    fill: "#FDC5D7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159.322,
    y: 762.55,
    width: 17.8354,
    height: 12.6,
    fill: "#FDC5D7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159.322,
    y: 775.15,
    width: 17.8354,
    height: 12.6,
    fill: "#FDC5D7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.7837,
    y: 762.55,
    width: 12.5897,
    height: 12.6,
    fill: "#FDC5D7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.963,
    y: 762.55,
    width: 12.5897,
    height: 12.6,
    fill: "#FDC5D7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.457,
    y: 775.15,
    width: 15.7371,
    height: 12.6,
    fill: "#FDC5D7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.457,
    y: 800.35,
    width: 15.7371,
    height: 12.6,
    fill: "#FDC5D7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.688,
    y: 749.95,
    width: 12.5897,
    height: 12.6,
    fill: "#FDC5D7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.8672,
    y: 749.95,
    width: 12.5897,
    height: 12.6,
    fill: "#FDC5D7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.1943,
    y: 749.95,
    width: 12.5897,
    height: 12.6,
    fill: "#FDC5D7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.7837,
    y: 737.35,
    width: 12.5897,
    height: 12.6,
    fill: "#FDC5D7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.3735,
    y: 749.95,
    width: 12.5897,
    height: 12.6,
    fill: "#FDC5D7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.553,
    y: 749.95,
    width: 12.5897,
    height: 12.6,
    fill: "#FDC5D7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.143,
    y: 737.35,
    width: 12.5897,
    height: 12.6,
    fill: "#FDC5D7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.732,
    y: 749.95,
    width: 12.5897,
    height: 12.6,
    fill: "#FDC5D7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 177.157,
    y: 749.95,
    width: 12.5897,
    height: 12.6,
    fill: "#FDC5D7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.337,
    y: 749.95,
    width: 12.5897,
    height: 12.6,
    fill: "#FDC5D7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 231.713,
    y: 749.95,
    width: 12.5897,
    height: 12.6,
    fill: "#FDC5D7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.219,
    y: 749.95,
    width: 12.5897,
    height: 12.6,
    fill: "#FDC5D7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.219,
    y: 775.15,
    width: 12.5897,
    height: 12.6,
    fill: "#FDC5D7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297.809,
    y: 762.55,
    width: 12.5897,
    height: 12.6,
    fill: "#FDC5D7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.398,
    y: 775.15,
    width: 12.5897,
    height: 12.6,
    fill: "#FDC5D7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338.725,
    y: 775.15,
    width: 12.5897,
    height: 12.6,
    fill: "#FDC5D7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.315,
    y: 762.55,
    width: 12.5897,
    height: 12.6,
    fill: "#FDC5D7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 363.904,
    y: 775.15,
    width: 12.5897,
    height: 12.6,
    fill: "#FDC5D7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376,
    y: 762.75,
    width: 16,
    height: 12,
    fill: "#FDC5D7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376,
    y: 774.75,
    width: 16,
    height: 13,
    fill: "#FDC5D7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.315,
    y: 787.75,
    width: 12.5897,
    height: 12.6,
    fill: "#FDC5D7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338.725,
    y: 787.75,
    width: 12.5897,
    height: 12.6,
    fill: "#FDC5D7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 363.904,
    y: 787.75,
    width: 12.5897,
    height: 12.6,
    fill: "#FDC5D7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 363.904,
    y: 800.35,
    width: 12.5897,
    height: 12.6,
    fill: "#FDC5D7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376,
    y: 800.75,
    width: 16,
    height: 12,
    fill: "#FDC5D7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338.725,
    y: 800.35,
    width: 12.5897,
    height: 12.6,
    fill: "#FDC5D7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.398,
    y: 749.95,
    width: 12.5897,
    height: 12.6,
    fill: "#FDC5D7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338.725,
    y: 749.95,
    width: 12.5897,
    height: 12.6,
    fill: "#FDC5D7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 363.904,
    y: 749.95,
    width: 12.5897,
    height: 12.6,
    fill: "#FDC5D7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.315,
    y: 737.35,
    width: 12.5897,
    height: 12.6,
    fill: "#FDC5D7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297.809,
    y: 737.35,
    width: 12.5897,
    height: 12.6,
    fill: "#FDC5D7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.302,
    y: 737.35,
    width: 12.5897,
    height: 12.6,
    fill: "#FDC5D7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.892,
    y: 749.95,
    width: 12.5897,
    height: 12.6,
    fill: "#FDC5D7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.074,
    y: 722.65,
    width: 12.5897,
    height: 12.6,
    fill: "#FDC5D7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.302,
    y: 709,
    width: 12.5897,
    height: 12.6,
    fill: "#FDC5D7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297.809,
    y: 709,
    width: 12.5897,
    height: 12.6,
    fill: "#FDC5D7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 270.531,
    y: 722.65,
    width: 12.5897,
    height: 12.6,
    fill: "#FDC5D7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 325.086,
    y: 722.65,
    width: 12.5897,
    height: 12.6,
    fill: "#FDC5D7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.315,
    y: 709,
    width: 12.5897,
    height: 12.6,
    fill: "#FDC5D7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 378.592,
    y: 722.65,
    width: 12.5897,
    height: 12.6,
    fill: "#FDC5D7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.747,
    y: 737.35,
    width: 12.5897,
    height: 12.6,
    fill: "#FDC5D7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.7837,
    y: 709,
    width: 12.5897,
    height: 12.6,
    fill: "#FDC5D7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.29,
    y: 709,
    width: 12.5897,
    height: 12.6,
    fill: "#FDC5D7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.747,
    y: 709,
    width: 12.5897,
    height: 12.6,
    fill: "#FDC5D7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321,
    y: 785.75,
    width: 5,
    height: 19,
    fill: "#FDC5D7"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 787.75,
    width: 392,
    height: 115,
    fill: "#FDC5D7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.688,
    y: 787.75,
    width: 12.5897,
    height: 12.6,
    fill: "#FDC5D7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.688,
    y: 812.95,
    width: 12.5897,
    height: 12.6,
    fill: "#FDC5D7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150.929,
    y: 800.35,
    width: 12.5897,
    height: 12.6,
    fill: "#FDC5D7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.457,
    y: 762.55,
    width: 15.7371,
    height: 12.6,
    fill: "#FDC5D7"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1717_2149)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.822 179.425H114.638V179.893C114.638 181.789 113.438 183.397 111.638 184.021L111.146 183.241C112.754 182.701 113.822 181.357 113.822 179.893V179.425ZM114.002 179.425H114.818V179.893C114.818 181.213 115.874 182.461 117.446 182.965L116.978 183.733C115.178 183.157 114.002 181.645 114.002 179.893V179.425ZM111.422 178.837H117.206V179.641H111.422V178.837ZM113.822 177.517H114.818V179.173H113.822V177.517ZM116.894 180.625H119.33V181.453H116.894V180.625ZM119.054 177.565H120.05V185.077H119.054V177.565ZM116.042 184.357H116.894V184.585C116.894 186.541 114.998 187.981 112.79 188.377L112.406 187.585C114.326 187.261 116.042 186.061 116.042 184.585V184.357ZM116.21 184.357H117.062V184.585C117.062 186.097 118.766 187.261 120.71 187.585L120.314 188.377C118.118 187.969 116.21 186.589 116.21 184.585V184.357ZM130.045 177.577H131.053V185.497H130.045V177.577ZM124.081 187.357H131.377V188.173H124.081V187.357ZM124.081 184.681H125.065V187.633H124.081V184.681ZM125.233 178.321C126.853 178.321 128.053 179.425 128.053 180.997C128.053 182.557 126.853 183.673 125.233 183.673C123.613 183.673 122.401 182.557 122.401 180.997C122.401 179.425 123.613 178.321 125.233 178.321ZM125.233 179.185C124.177 179.185 123.373 179.929 123.373 180.997C123.373 182.053 124.177 182.797 125.233 182.797C126.289 182.797 127.093 182.053 127.093 180.997C127.093 179.929 126.289 179.185 125.233 179.185ZM135.828 178.129H136.656V179.233C136.656 181.321 135.48 183.049 133.668 183.757L133.14 182.953C134.772 182.353 135.828 180.889 135.828 179.233V178.129ZM136.008 178.129H136.824V179.305C136.824 180.769 137.904 182.125 139.464 182.665L138.936 183.445C137.196 182.797 136.008 181.189 136.008 179.305V178.129ZM140.616 177.565H141.612V184.141H140.616V177.565ZM141.336 180.361H143.22V181.201H141.336V180.361ZM138.156 184.441C140.376 184.441 141.72 185.173 141.72 186.421C141.72 187.669 140.376 188.389 138.156 188.389C135.936 188.389 134.592 187.669 134.592 186.421C134.592 185.173 135.936 184.441 138.156 184.441ZM138.156 185.233C136.548 185.233 135.564 185.665 135.564 186.421C135.564 187.177 136.548 187.609 138.156 187.609C139.764 187.609 140.748 187.177 140.748 186.421C140.748 185.665 139.764 185.233 138.156 185.233ZM150.314 179.353H151.13V179.821C151.13 181.669 149.906 183.169 148.082 183.745L147.614 182.965C149.222 182.473 150.314 181.237 150.314 179.821V179.353ZM150.494 179.353H151.31V179.821C151.31 181.117 152.366 182.293 153.962 182.761L153.494 183.529C151.682 182.989 150.494 181.549 150.494 179.821V179.353ZM147.914 178.825H153.698V179.629H147.914V178.825ZM150.314 177.517H151.31V179.161H150.314V177.517ZM155.03 177.565H156.026V183.865H155.03V177.565ZM155.75 180.241H157.634V181.069H155.75V180.241ZM152.138 184.765H152.99V185.053C152.99 186.757 151.19 188.017 149.066 188.377L148.682 187.609C150.554 187.321 152.138 186.265 152.138 185.053V184.765ZM152.33 184.765H153.182V185.053C153.182 186.241 154.79 187.321 156.626 187.621L156.254 188.389C154.13 188.029 152.33 186.721 152.33 185.053V184.765ZM149.102 184.453H156.218V185.257H149.102V184.453ZM166.549 177.565H167.545V188.413H166.549V177.565ZM163.369 178.729H164.353C164.353 181.873 162.937 184.621 159.313 186.397L158.785 185.593C161.917 184.081 163.369 181.777 163.369 178.897V178.729ZM159.277 178.729H163.801V179.545H159.277V178.729ZM173.067 186.193H182.895V187.021H173.067V186.193ZM173.919 178.645H181.971V179.461H173.919V178.645ZM173.943 183.229H181.959V184.045H173.943V183.229ZM175.611 179.401H176.607V183.313H175.611V179.401ZM179.307 179.401H180.291V183.313H179.307V179.401ZM111.122 201.253H120.95V202.081H111.122V201.253ZM115.514 198.925H116.51V201.601H115.514V198.925ZM112.31 193.369H119.738V196.657H113.33V198.829H112.346V195.853H118.754V194.173H112.31V193.369ZM112.346 198.409H119.99V199.225H112.346V198.409ZM126.637 195.361H128.617V196.177H126.637V195.361ZM128.257 192.793H129.193V199.105H128.257V192.793ZM124.405 193.993H125.185V194.881C125.185 196.561 124.309 198.229 122.713 198.937L122.197 198.169C123.589 197.569 124.405 196.177 124.405 194.881V193.993ZM124.573 193.993H125.353V194.869C125.353 196.069 126.133 197.353 127.477 197.917L126.973 198.685C125.401 198.025 124.573 196.441 124.573 194.869V193.993ZM122.401 193.441H127.225V194.257H122.401V193.441ZM130.345 192.565H131.293V199.189H130.345V192.565ZM124.021 199.669H131.293V203.413H130.309V200.485H124.021V199.669ZM134.46 198.409H141.912V199.213H134.46V198.409ZM133.2 201.193H143.028V202.021H133.2V201.193ZM134.46 193.489H141.792V194.305H135.468V198.661H134.46V193.489ZM135.144 195.913H141.564V196.705H135.144V195.913Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.113 271.473H208.929V271.941C208.929 273.837 207.729 275.445 205.929 276.069L205.437 275.289C207.045 274.749 208.113 273.405 208.113 271.941V271.473ZM208.293 271.473H209.109V271.941C209.109 273.261 210.165 274.509 211.737 275.013L211.269 275.781C209.469 275.205 208.293 273.693 208.293 271.941V271.473ZM205.713 270.885H211.497V271.689H205.713V270.885ZM208.113 269.565H209.109V271.221H208.113V269.565ZM211.185 272.673H213.621V273.501H211.185V272.673ZM213.345 269.613H214.341V277.125H213.345V269.613ZM210.333 276.405H211.185V276.633C211.185 278.589 209.289 280.029 207.081 280.425L206.697 279.633C208.617 279.309 210.333 278.109 210.333 276.633V276.405ZM210.501 276.405H211.353V276.633C211.353 278.145 213.057 279.309 215.001 279.633L214.605 280.425C212.409 280.017 210.501 278.637 210.501 276.633V276.405ZM224.337 269.625H225.345V277.545H224.337V269.625ZM218.373 279.405H225.669V280.221H218.373V279.405ZM218.373 276.729H219.357V279.681H218.373V276.729ZM219.525 270.369C221.145 270.369 222.345 271.473 222.345 273.045C222.345 274.605 221.145 275.721 219.525 275.721C217.905 275.721 216.693 274.605 216.693 273.045C216.693 271.473 217.905 270.369 219.525 270.369ZM219.525 271.233C218.469 271.233 217.665 271.977 217.665 273.045C217.665 274.101 218.469 274.845 219.525 274.845C220.581 274.845 221.385 274.101 221.385 273.045C221.385 271.977 220.581 271.233 219.525 271.233ZM230.12 270.177H230.948V271.281C230.948 273.369 229.772 275.097 227.96 275.805L227.432 275.001C229.064 274.401 230.12 272.937 230.12 271.281V270.177ZM230.3 270.177H231.116V271.353C231.116 272.817 232.196 274.173 233.756 274.713L233.228 275.493C231.488 274.845 230.3 273.237 230.3 271.353V270.177ZM234.908 269.613H235.904V276.189H234.908V269.613ZM235.628 272.409H237.512V273.249H235.628V272.409ZM232.448 276.489C234.668 276.489 236.012 277.221 236.012 278.469C236.012 279.717 234.668 280.437 232.448 280.437C230.228 280.437 228.884 279.717 228.884 278.469C228.884 277.221 230.228 276.489 232.448 276.489ZM232.448 277.281C230.84 277.281 229.856 277.713 229.856 278.469C229.856 279.225 230.84 279.657 232.448 279.657C234.056 279.657 235.04 279.225 235.04 278.469C235.04 277.713 234.056 277.281 232.448 277.281ZM244.606 271.401H245.422V271.869C245.422 273.717 244.198 275.217 242.374 275.793L241.906 275.013C243.514 274.521 244.606 273.285 244.606 271.869V271.401ZM244.786 271.401H245.602V271.869C245.602 273.165 246.658 274.341 248.254 274.809L247.786 275.577C245.974 275.037 244.786 273.597 244.786 271.869V271.401ZM242.206 270.873H247.99V271.677H242.206V270.873ZM244.606 269.565H245.602V271.209H244.606V269.565ZM249.322 269.613H250.318V275.913H249.322V269.613ZM250.042 272.289H251.926V273.117H250.042V272.289ZM246.43 276.813H247.282V277.101C247.282 278.805 245.482 280.065 243.358 280.425L242.974 279.657C244.846 279.369 246.43 278.313 246.43 277.101V276.813ZM246.622 276.813H247.474V277.101C247.474 278.289 249.082 279.369 250.918 279.669L250.546 280.437C248.422 280.077 246.622 278.769 246.622 277.101V276.813ZM243.394 276.501H250.51V277.305H243.394V276.501ZM260.841 269.613H261.837V280.461H260.841V269.613ZM257.661 270.777H258.645C258.645 273.921 257.229 276.669 253.605 278.445L253.077 277.641C256.209 276.129 257.661 273.825 257.661 270.945V270.777ZM253.569 270.777H258.093V271.593H253.569V270.777ZM267.359 278.241H277.187V279.069H267.359V278.241ZM268.211 270.693H276.263V271.509H268.211V270.693ZM268.235 275.277H276.251V276.093H268.235V275.277ZM269.903 271.449H270.899V275.361H269.903V271.449ZM273.599 271.449H274.583V275.361H273.599V271.449ZM205.413 293.301H215.241V294.129H205.413V293.301ZM209.805 290.973H210.801V293.649H209.805V290.973ZM206.601 285.417H214.029V288.705H207.621V290.877H206.637V287.901H213.045V286.221H206.601V285.417ZM206.637 290.457H214.281V291.273H206.637V290.457ZM220.929 287.409H222.909V288.225H220.929V287.409ZM222.549 284.841H223.485V291.153H222.549V284.841ZM218.697 286.041H219.477V286.929C219.477 288.609 218.601 290.277 217.005 290.985L216.489 290.217C217.881 289.617 218.697 288.225 218.697 286.929V286.041ZM218.865 286.041H219.645V286.917C219.645 288.117 220.425 289.401 221.769 289.965L221.265 290.733C219.693 290.073 218.865 288.489 218.865 286.917V286.041ZM216.693 285.489H221.517V286.305H216.693V285.489ZM224.637 284.613H225.585V291.237H224.637V284.613ZM218.313 291.717H225.585V295.461H224.601V292.533H218.313V291.717ZM228.752 290.457H236.204V291.261H228.752V290.457ZM227.492 293.241H237.32V294.069H227.492V293.241ZM228.752 285.537H236.084V286.353H229.76V290.709H228.752V285.537ZM229.436 287.961H235.856V288.753H229.436V287.961Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.385 73.552H30.5757V312.373H179.385V73.552Z",
    fill: "#6C5244"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.626 73.552H179.449V312.373H362.626V73.552Z",
    fill: "#CAA170"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.686 313.542H169.583V339.034H372.686V313.542Z",
    fill: "#CAA170"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.512 313.542H20.1587V339.034H169.512V313.542Z",
    fill: "#6C5244"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334 99H52V292H334V99Z",
    fill: "#056839",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.705 73.4307H30.7188V313.428H362.705V73.4307Z",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330 106H69V287H330V106Z",
    fill: "#A0DA53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.757 313.421H20.3018V338.913H372.757V313.421Z",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.22 124.939H91.1567V224.217H298.22V124.939Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.929 134.425H81.769V215.431H307.929V134.425Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.929 206.685H190.709V247.115H216.929V206.685Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.021 243.142H199.409V255.26H225.021V243.142Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.835 249.121H211.63V263.606H225.835V249.121Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.227 118H91.3306V124.939H298.227V118Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.99 224.217H93.502V231.156H190.99V224.217Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.138 224.217H216.321V231.156H297.138V224.217Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.64 134.099H307.929V215.104H318.64V134.099Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.922 215.111H297.138V224.217H307.922V215.111Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.5022 215.431H82.7178V224.537H93.5022V215.431Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.711 134.425H72V215.431H82.711V134.425Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.3307 124.939H82.7178V134.425H91.3307V124.939Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.929 124.939H298.227V134.425H307.929V124.939Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.99 224.217H182.25V247.108H190.99V224.217Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.061 224.217H216.321V247.108H225.061V224.217Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.8 247.108H225.061V269.999H233.8V247.108Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.449 247.108H190.709V255.32H199.449V247.108Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.403 255.321H199.409V263.533H211.403V255.321Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.811 263.54H211.403V270.006H226.811V263.54Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.948 270.006H233.687V277.818H242.948V270.006Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.114 210.565H94V217.011H100.114V210.565Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.228 217.011H100.114V223.457H106.228V217.011Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.689 210.565H106.228V217.011H112.689V210.565Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.478 217.011H112.683V223.457H119.478V217.011Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.273 210.565H119.478V217.011H126.273V210.565Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.735 217.011H126.273V223.457H132.735V217.011Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.962 210.565H132.728V217.011H138.962V210.565Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.557 217.011H138.962V223.457H145.557V217.011Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.791 210.565H145.557V217.011H151.791V210.565Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.393 217.011H151.798V223.457H158.393V217.011Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.988 210.565H158.393V217.011H164.988V210.565Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.576 217.011H164.981V223.457H171.576V217.011Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.171 210.565H171.576V217.011H178.171V210.565Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.766 217.011H178.171V223.457H184.766V217.011Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.248 210.565H184.653V217.011H191.248V210.565Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.843 217.011H191.248V223.457H197.843V217.011Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.437 210.565H197.842V217.011H204.437V210.565Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.032 217.011H204.438V223.457H211.032V217.011Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.628 210.565H211.033V217.011H217.628V210.565Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.222 217.011H217.627V223.457H224.222V217.011Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.817 210.565H224.222V217.011H230.817V210.565Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.412 217.011H230.817V223.457H237.412V217.011Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.346 210.565H237.412V217.011H243.346V210.565Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.934 217.011H243.339V223.457H249.934V217.011Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.221 210.565H249.934V217.011H256.221V210.565Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.509 217.011H256.222V223.457H262.509V217.011Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.278 210.565H262.509V217.011H269.278V210.565Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.047 217.011H269.278V223.457H276.047V217.011Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.869 210.565H276.1V217.011H282.869V210.565Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.638 217.011H282.869V223.457H289.638V217.011Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.406 210.565H289.637V217.011H296.406V210.565Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.939 157.845H104V203.238H112.939V157.845Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.501 157.845H140.562V203.238H149.501V157.845Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.426 157.845H156.487V203.238H165.426V157.845Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.786 157.845H174.848V203.238H183.786V157.845Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.195 157.845H191.256V203.238H200.195V157.845Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.045 157.845H208.106V203.238H217.045V157.845Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.468 157.845H243.529V203.238H252.468V157.845Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.29 157.845H259.352V203.238H268.29V157.845Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.809 157.845H277.87V203.238H286.809V157.845Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.057 194.32H266.014V203.238H279.057V194.32Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.903 157.845H163.86V166.763H176.903V157.845Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.427 176.086H163.385V185.004H176.427V176.086Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.409 175.322H121.926V184.24H131.409V175.322Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.893 166.405H131.409V175.322H140.893V166.405Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.925 166.597H112.442V175.515H121.925V166.597Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.908 175.515H225.424V184.432H234.908V175.515Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.391 166.597H234.908V175.515H244.391V166.597Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.425 166.79H215.941V175.708H225.425V166.79Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.583 142.537C109.576 143.897 110.581 145.244 112.522 145.777L111.825 146.953C110.417 146.563 109.405 145.723 108.852 144.663C108.312 145.866 107.293 146.816 105.837 147.281L105.099 146.078C107.047 145.483 108.065 144.041 108.065 142.537V142.414H105.481V141.211H108.065V139.816H109.597V141.211H112.167V142.414H109.583V142.537ZM106.589 150.959C109.016 150.583 110.602 149.168 110.608 147.787V147.555H112.181V147.787C112.167 149.236 113.712 150.61 116.214 150.959L115.612 152.148C113.637 151.848 112.126 150.925 111.381 149.653C110.622 150.904 109.104 151.854 107.136 152.148L106.589 150.959ZM111.812 144.465V143.221H113.972V139.857H115.489V148.334H113.972V144.465H111.812ZM127.534 139.871V148.799H126.003V139.871H127.534ZM117.458 143.768C117.458 141.97 118.914 140.685 120.794 140.678C122.674 140.685 124.123 141.97 124.116 143.768C124.123 145.593 122.674 146.871 120.794 146.871C118.914 146.871 117.458 145.593 117.458 143.768ZM118.948 143.768C118.941 144.861 119.734 145.545 120.794 145.545C121.826 145.545 122.626 144.861 122.626 143.768C122.626 142.701 121.826 142.004 120.794 142.004C119.734 142.004 118.941 142.701 118.948 143.768ZM119.358 151.971V147.896H120.89V150.74H127.876V151.971H119.358ZM133.714 141.826C133.714 143.378 134.719 144.848 136.626 145.449L135.806 146.639C134.473 146.188 133.516 145.285 132.976 144.137C132.442 145.449 131.444 146.481 130.022 146.98L129.202 145.791C131.191 145.101 132.189 143.453 132.196 141.689V140.514H133.714V141.826ZM130.884 149.852C130.884 148.389 132.49 147.521 135.067 147.527C137.624 147.521 139.203 148.389 139.21 149.852C139.203 151.349 137.624 152.203 135.067 152.203C132.49 152.203 130.884 151.349 130.884 149.852ZM132.401 149.852C132.401 150.617 133.372 151 135.067 151C136.756 151 137.706 150.617 137.706 149.852C137.706 149.127 136.756 148.717 135.067 148.717C133.372 148.717 132.401 149.127 132.401 149.852ZM137.569 147.254V139.857H139.087V142.865H140.81V144.123H139.087V147.254H137.569ZM149.204 142.387C149.197 143.713 150.202 145.012 152.144 145.531L151.46 146.693C150.031 146.311 149.013 145.49 148.459 144.438C147.912 145.6 146.873 146.502 145.417 146.926L144.692 145.723C146.641 145.196 147.687 143.836 147.687 142.387V142.346H145.103V141.143H147.687V139.803H149.218V141.143H151.788V142.346H149.204V142.387ZM145.909 151C148.028 150.713 149.402 149.783 149.696 148.73H146.415V147.514H154.687V148.73H151.419C151.713 149.756 153.094 150.72 155.206 151.014L154.659 152.176C152.725 151.902 151.262 151.075 150.551 149.954C149.84 151.068 148.384 151.875 146.47 152.148L145.909 151ZM152.991 146.939V139.857H154.509V142.729H156.231V143.986H154.509V146.939H152.991ZM167.183 139.857V152.217H165.651V139.857H167.183ZM156.942 148.812C160.183 147.274 161.673 145.183 161.946 142.373H157.571V141.17H163.491C163.491 144.848 162.062 147.972 157.735 150.029L156.942 148.812ZM183.575 149.455V150.727H172.282V149.455H183.575ZM173.212 142.223V141.006H182.591V142.223H180.786V146.16H182.55V147.363H173.253V146.16H174.989V142.223H173.212ZM176.507 146.16H179.282V142.223H176.507V146.16ZM195.675 149.523V150.781H184.382V149.523H189.249V147.514H185.722V143.467H192.831V141.936H185.694V140.705H194.335V144.67H187.239V146.27H194.622V147.514H190.753V149.523H195.675ZM204.616 140.117V147.309H203.167V144.191H201.622V142.961H203.167V140.117H204.616ZM196.386 146.037C198.04 145.388 198.819 143.911 198.819 142.51V142.018H196.741V140.801H202.251V142.018H200.296V142.51C200.296 143.829 201.027 145.176 202.606 145.805L201.841 146.967C200.754 146.536 200.009 145.75 199.578 144.8C199.141 145.866 198.354 146.755 197.179 147.227L196.386 146.037ZM198.587 149.1V147.883H207.05V152.217H205.532V149.1H198.587ZM205.601 147.391V139.857H207.05V147.391H205.601ZM218.63 146.338V147.541H209.962V140.828H218.521V142.059H211.507V143.549H218.233V144.738H211.507V146.338H218.63ZM208.581 150.713V149.469H219.874V150.713H208.581Z",
    fill: "#7A9340"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M21.8198 435.625L74.589 386.625H315.651L368.42 435.625H21.8198Z",
    fill: "#F5D39A",
    stroke: "black",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 251.869,
    y1: 434.51,
    x2: 243.176,
    y2: 385.261,
    stroke: "black",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 437V447H370V437",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 146.477,
    y1: 385.385,
    x2: 137.477,
    y2: 436.385,
    stroke: "black",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369 437H21V446H369V437Z",
    fill: "#6C5244"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 137.5,
    y1: 435,
    x2: 137.5,
    y2: 447,
    stroke: "black",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 252.5,
    y1: 435,
    x2: 252.5,
    y2: 447,
    stroke: "black",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.747 500.627V495.077H57.9502V500.627H145.747Z",
    fill: "#696B6D",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.708 500.623V495.073H239.723V500.623H325.708Z",
    fill: "#696B6D",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.84 500.622V495.073H163.967V500.622H220.84Z",
    fill: "#696B6D",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6068 450H26V525.196H31.6068V450Z",
    fill: "#99999C",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.377 450H110.691V525.196H116.377V450Z",
    fill: "#696B6D",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.016 450H130.323V525.196H136.016V450Z",
    fill: "#99999C",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.325 450H249.273V525.196H255.325V450Z",
    fill: "#99999C",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.964 450H268.933V525.196H274.964V450Z",
    fill: "#99999C",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.306 450H357.513V525.196H364.306V450Z",
    fill: "#99999C",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.103 450H326.554V509.878H332.103V450Z",
    fill: "#99999C",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.72 450H234.17V509.878H239.72V450Z",
    fill: "#99999C",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.429 450H220.88V509.878H226.429V450Z",
    fill: "#99999C",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.978 450H158.429V509.878H163.978V450Z",
    fill: "#99999C",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.298 450H145.749V509.878H151.298V450Z",
    fill: "#99999C",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.9516 450H52.4023V509.878H57.9516V450Z",
    fill: "#99999C",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.8736 450.604H53.3657V477.718H56.8736V450.604Z",
    fill: "#696B6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.27 450.604H146.762V477.718H150.27V450.604Z",
    fill: "#696B6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.957 451.029H159.449V478.143H162.957V451.029Z",
    fill: "#696B6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.887 451.029H131.365V478.143H134.887V451.029Z",
    fill: "#696B6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.27 492.325H111.849V505.415H115.27V492.325Z",
    fill: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.277 508.764H111.849V512.193H115.277V508.764Z",
    fill: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.082 451.029H327.574V478.143H331.082V451.029Z",
    fill: "#696B6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.699 451.029H235.191V478.143H238.699V451.029Z",
    fill: "#696B6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.915 450.762H269.939V524.089H273.915V450.762Z",
    fill: "#696B6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.283 450.992H250.308V497.845H254.283V450.992Z",
    fill: "#696B6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.283 509.397H250.308V524.097H254.283V509.397Z",
    fill: "#696B6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.401 451.029H221.893V503.416H225.401V451.029Z",
    fill: "#696B6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.625 324.837H64.8013V394.023H108.625V324.837Z",
    fill: "#FFFEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.604 331.085H72.7803V400.155H116.604V331.085Z",
    fill: "#FFFEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.862 339.129H80.0391V408.316H123.862V339.129Z",
    fill: "#FFFEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.532 349.313H86.709V400.162H130.532V349.313Z",
    fill: "#FFFEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.0849 325.179H59.1787V388.008H65.0849V325.179Z",
    fill: "#EE6369"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.7147 331.085H64.8086V393.914H70.7147V331.085Z",
    fill: "#EE6369"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.0463 336.984H70.1401V399.813H76.0463V336.984Z",
    fill: "#EE6369"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.854 325.179H103.948V331.085H109.854V325.179Z",
    fill: "#EE6369"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.215 336.984H115.6V342.89H121.215V336.984Z",
    fill: "#EE6369"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.048 342.89H121.215V353.713H127.048V342.89Z",
    fill: "#EE6369"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.5811 342.89H76.0459V353.713H81.5811V342.89Z",
    fill: "#EE6369"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.4126 342.89H81.5889V348.069H98.4126V342.89Z",
    fill: "#EE6369"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.854 342.89H104.355V348.069H109.854V342.89Z",
    fill: "#EE6369"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.854 320H59.1787V325.179H109.854V320Z",
    fill: "#C2313C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.055 405.726H76.0459V410.905H127.055V405.726Z",
    fill: "#C2313C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.5667 399.813H76.0679V405.726H81.5667V399.813Z",
    fill: "#EE6369"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.056 399.813H121.019V405.726H127.056V399.813Z",
    fill: "#EE6369"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.227 342.89H127.048V405.719H132.227V342.89Z",
    fill: "#C2313C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.1788 325.179H54V388.008H59.1788V325.179Z",
    fill: "#C2313C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.607 325.179H109.861V331.085H115.607V325.179Z",
    fill: "#C2313C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.215 331.085H115.6V336.991H121.215V331.085Z",
    fill: "#C2313C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.048 336.984H121.215V342.89H127.048V336.984Z",
    fill: "#C2313C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.0463 399.813H70.1401V405.719H76.0463V399.813Z",
    fill: "#C2313C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.1401 393.899H64.8086V399.806H70.1401V393.899Z",
    fill: "#C2313C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.8012 388.008H59.1787V393.914H64.8012V388.008Z",
    fill: "#C2313C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.2999 372.581H84.52V375.723H99.2999V372.581Z",
    fill: "#101010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.379 372.581H107.599V375.723H122.379V372.581Z",
    fill: "#101010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.8 380.312H96.02V383.455H110.8V380.312Z",
    fill: "#101010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.6483 378.741H84.52V381.883H93.6483V378.741Z",
    fill: "#F8AB86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.379 378.741H113.25V381.883H122.379V378.741Z",
    fill: "#F8AB86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.355 342.89H98.4053V348.069H104.355V342.89Z",
    fill: "#FBF3D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.215 342.89H109.81V348.069H121.215V342.89Z",
    fill: "#FBF3D8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246,
    y: 320,
    width: 100,
    height: 100,
    fill: "url(#pattern1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.869 325.889H183.131V357.354H205.869V325.889Z",
    fill: "#F7EE7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.59 360.917H158.782V392.382H225.59V360.917Z",
    fill: "#F7EE7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.995 333.015H166.082V407.852H221.995V333.015Z",
    fill: "#F7EE7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.068 338.782H211.589V355.821H224.068V338.782Z",
    fill: "#F4D252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.544 344.502H216.952V362.748H228.544V344.502Z",
    fill: "#F4D252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.71 338.782H164.481V355.821H177.71V338.782Z",
    fill: "#F4D252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.906 344.502H160.456V361.583H171.906V344.502Z",
    fill: "#F4D252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.365 361.583H160.456V367.308H166.365V361.583Z",
    fill: "#F4D252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.549 362.208H222.64V407.248H228.549V362.208Z",
    fill: "#F4D252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.034 390.041H217.125V407.248H223.034V390.041Z",
    fill: "#F4D252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.125 396.239H211.216V407.248H217.125V396.239Z",
    fill: "#F4D252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.778 401.974H205.869V407.248H211.778V401.974Z",
    fill: "#F4D252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.365 389.8H160.456V407.248H166.365V389.8Z",
    fill: "#F4D252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.99 396.065H166.082V407.248H171.99V396.065Z",
    fill: "#F4D252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.516 401.654H171.607V407.248H177.516V401.654Z",
    fill: "#F4D252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.702 344.502H188.793V350.096H194.702V344.502Z",
    fill: "#F4D252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.589 344.502H200.191V350.096H211.589V344.502Z",
    fill: "#F4D252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.456 344.502H155.188V407.248H160.456V344.502Z",
    fill: "#F3BE17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.818 344.502H228.549V407.248H233.818V344.502Z",
    fill: "#F3BE17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.549 407.248H160.456V412.842H228.549V407.248Z",
    fill: "#F3BE17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.296 327.295H204.898V333.141H216.296V327.295Z",
    fill: "#F3BE17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.939 327.421H172.542V333.015H183.939V327.421Z",
    fill: "#F3BE17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.547 327.421H166.848V333.015H172.547V327.421Z",
    fill: "#F3BE17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.031 333.015H163.332V338.783H169.031V333.015Z",
    fill: "#F3BE17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.481 338.74H158.782V344.508H164.481V338.74Z",
    fill: "#F3BE17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.995 327.295H216.296V333.141H221.995V327.295Z",
    fill: "#F3BE17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.93 333.141H220.231V338.783H225.93V333.141Z",
    fill: "#F3BE17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.767 338.803H224.068V344.502H229.767V338.803Z",
    fill: "#F3BE17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.291 321.833H172.542V327.427H216.291V321.833Z",
    fill: "#F3BE17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.793 344.502H177.71V350.096H188.793V344.502Z",
    fill: "#FEF1D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.191 344.502H194.702V350.096H200.191V344.502Z",
    fill: "#FEF1D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.182 367H204.916V369.884H213.182V367Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.91 369.889H202.026V378.201H204.91V369.889Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.066 369.889H213.182V378.201H216.066V369.889Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.228 378.201H204.916V380.518H213.228V378.201Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.545 367H173.279V369.884H181.545V367Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.279 369.889H170.395V378.201H173.279V369.889Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.429 369.889H181.545V378.201H184.429V369.889Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.809 386.114H198.075V383.23H189.809V386.114Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.078 383.228H200.962V377.704H198.078V383.228Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.928 383.228H189.812V377.704H186.928V383.228Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.494 369.889H204.916V378.201H207.494V369.889Z",
    fill: "#393A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.182 372.717H210.412V378.201H213.182V372.717Z",
    fill: "#393A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.406 375.459H207.488V378.201H210.406V375.459Z",
    fill: "#393A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.406 369.889H207.488V372.717H210.406V369.889Z",
    fill: "#393A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.406 372.717H207.488V375.544H210.406V372.717Z",
    fill: "#8E8E8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.182 369.889H210.355V372.717H213.182V369.889Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.987 380.467H204.831V383.323H215.987V380.467Z",
    fill: "#F4A688"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.156 380H171V382.855H182.156V380Z",
    fill: "#F4A688"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1717_2149",
    transform: "scale(0.00222222 0.004)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern1",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image1_1717_2149",
    transform: "scale(0.00239808)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1717_2149",
    x1: 587,
    y1: 1700,
    x2: 587,
    y2: 848,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD2DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7F9",
    stopOpacity: 0.58
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1717_2149"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 390,
    height: 844,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1717_2149"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 385,
    height: 293,
    fill: "white",
    transform: "translate(3 60)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1717_2149",
    width: 450,
    height: 250,
    xlinkHref: "data:image/png;base64,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"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image1_1717_2149",
    width: 417,
    height: 417,
    xlinkHref: "data:image/png;base64,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"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallPaper);
export default __webpack_public_path__ + "static/media/WallPaper.65822351604e036412d1a20a1ef0ca1f.svg";
export { ForwardRef as ReactComponent };